import { Button } from "primereact/button";
import { Checkbox } from "primereact/checkbox";
import { Dialog } from "primereact/dialog";
import React, { useEffect, useState } from "react";
import SuccessModal from "../../SuccessModal";
import { getWarehouseProcessStageAppServiceStage, postWarehouseProcessStageAppServiceStage } from "../../../services/WarehouseStage/WarehouseStage";

const WHProcessStageListAppServiceAddModal = ({
  wHProcessStageListAppServiceAddModalVisible,
  setWHProcessStageListAppServiceAddModalVisible,
  sendDataToAppService,
  brandId,
  selectedAppServiceValue,
  selectedItemValue
}) => {
  const OrderStatus = selectedAppServiceValue;
  const wareHouseGarmentProcessStageId = selectedItemValue?.id
  const [appServiceMap, setAppServiceMap] = useState({});

  const [selectedStatus, setSelectedStatus] = useState([]);
  const [modalVisible, setModalVisible] = useState(false);
  const [modalStatus, setModalStatus] = useState(false);
  const [modalText, setModalText] = useState("");

  const handleAppServicesListView = id => {
    getWarehouseProcessStageAppServiceStage(id)
      .then(response => {
        if (!response.data.error) {
         const Res = response.data;
         setAppServiceMap(Res);


         // Pre-select items that are already matched
         const existingServiceNames = Object.values(
           Res?.stageAppServices || {},
         );
         const matchedItems = OrderStatus?.filter(item =>
           existingServiceNames.includes(item.appService.name),
         );
         setSelectedStatus(matchedItems || []);
        }
      })
      .catch(err => {
        console.error('Error:', err);
      });
  };


  useEffect(() => {
    handleAppServicesListView(selectedItemValue?.id);
  }, [wHProcessStageListAppServiceAddModalVisible]);

  const handleStatusToggle = item => {
    const exists = selectedStatus.some(i => i.id === item.id);


    if (exists) {
      setSelectedStatus(prev => prev.filter(i => i.id !== item.id));
    } else {
      setSelectedStatus(prev => [...prev, item]);
    }
  };
 


  const handleDataSubmit = () => {
    const updatedData = {
      appServiceList: selectedStatus.map(item => item.appService.id),
      wareHouseGarmentProcessStageId: selectedItemValue?.id,
    };

    postWarehouseProcessStageAppServiceStage(updatedData)
      .then(response => {
        if (!response.data.error) {
          const Res = response.data;
          if (Res) {
            const message = Res.message;
            const status = Res.status;
            setWHProcessStageListAppServiceAddModalVisible(false);
            sendDataToAppService({
              success: true,
            });
            if (status === true) {
              setModalVisible(true);
              setModalStatus('success');
              setModalText(message);
            } else {
              setModalVisible(true);
              setModalStatus('not Success');
              setModalText(message);
            }
            setSelectedStatus([]);
          }
        }
      })
      .catch(err => {
        console.error('Error:', err);
      });
  };

  const handleModalClose = () => {
    setWHProcessStageListAppServiceAddModalVisible(false);
    setSelectedStatus([]);
  };

  return (
    <div className="flex justify-content-center">
      <Dialog
        modal
        visible={wHProcessStageListAppServiceAddModalVisible}
        style={{ width: "50vw" }}
        onHide={() => {
          if (!wHProcessStageListAppServiceAddModalVisible) return;
          handleModalClose();
        }}
        content={({ hide }) => (
          <div
            className="flex flex-column gap-1 "
            style={{
              borderRadius: "12px",
              backgroundColor: "#fff",
            }}
          >
            <div
              className="flex border-round-xl  justify-content-between align-items-center gap-2 px-4 py-2"
              style={{
                backgroundImage:
                  "radial-gradient(circle at left top, #2B70D7, #1752AA)",
              }}
            >
              <img
                style={{
                  height: 45,
                  width: 45,
                  // alignSelf: 'center',
                }}
                src={"images/plus.png"}
              />

              <p className=" text-4xl text-primary-50 font-semibold">
                ADD SERVICE
              </p>
              <Button
                label="x"
                onClick={(e) => hide(e)}
                text
                className=" text-2xl text-primary-50 border-1 border-white-alpha-30 hover:bg-white-alpha-10"
              ></Button>
            </div>

            <div
              className="h-20rem scroll-bar mb-2"
              style={{
                overflowY: "scroll",
              }}
            >
              <div className="mx-4">
                {OrderStatus?.length > 0 ? (
                  OrderStatus?.map(
                    (item) =>
                      item.status === true && (
                        <div
                          key={item.appService.id}
                          className="flex flex-1 justify-content-between my-1"
                        >
                          <p className="text-xl font-medium">
                            {item.appService.name}
                          </p>
                          <div>
                            <Checkbox
                              checked={selectedStatus.some(
                                i => i.id === item.id,
                              )}
                              color={
                                selectedStatus.some(i => i.id === item.id)
                                  ? '#00A3FF'
                                  : '#C1C9D3'
                              }

                              size="20" // Increased size
                              onClick={() => handleStatusToggle(item)}
                            />
                          </div>
                        </div>
                      )
                  )
                ) : (
                  <div>
                    <p className="text-xl font-medium">No Services Found</p>
                  </div>
                )}
              </div>
            </div>

            {OrderStatus?.length !== 0 && (
              <Button
                onClick={handleDataSubmit}
                className="mt-1 mb-3 mx-4 border-round-xl "
                disabled={selectedStatus?.length <= 0 && true}
              >
                <p className=" w-full text-2xl font-semibold flex justify-content-center">
                  SAVE
                </p>
              </Button>
            )}
          </div>
        )}
      ></Dialog>
      <div>
        <SuccessModal
          modalVisible={modalVisible}
          setModalVisible={setModalVisible}
          status={modalStatus}
          text={modalText}
        />
      </div>
    </div>
  );
};

export default WHProcessStageListAppServiceAddModal;
